let language = {

    RESET_PASSWORD_CHANGE_PASSWORD_TITLE: "Change password",

    RESET_PASSWORD_FORM_PASSWORD_LABEL: "Password:",
    RESET_PASSWORD_FORM_PASSWORD_PLACEHOLDER: "Please enter password",
    RESET_PASSWORD_FORM_PASSWORD_ERROR_TIP1: "Please input 8 to 20 characters,including uppercase,lowercase,numbers and symbols",
    RESET_PASSWORD_FORM_REPEAT_PASSWORD_LABEL: "Confirm Password:",
    RESET_PASSWORD_FORM_REPEAT_PASSWORD_PLACEHOLDER: "Please check password",
    RESET_PASSWORD_FORM_REPEAT_PASSWORD_ERROR_TIP1: "Your 'confirm password' should be the same as your password",
    RESET_PASSWORD_FORM_REPEAT_PASSWORD_ERROR_TIP2: "Your password cannot be the same as your email address",
    RESET_PASSWORD_FORM_REPEAT_PASSWORD_ERROR_TIP3: "Your new password and old password cannot be the same",
    RESET_PASSWORD_FORM_REPEAT_PASSWORD_ERROR_TIP4: "Your password cannot be the same as your account full name",
    RESET_PASSWORD_FORM_SUBMIT_BTN: "Change Password",
    RESET_PASSWORD_FORM_FAILED_TITLE: "Password reset unsuccessful",
    RESET_PASSWORD_FORM_FAILED_CONTENT1: "Your password cannot be the same as your email address. Please enter another password and try again.",
    RESET_PASSWORD_FORM_FAILED_CONTENT2: "Your password reset request has expired. Please reapply and then set your new password and try again.",
    RESET_PASSWORD_FORM_FAILED_CONTENT3: "Your new password is the same as your old password. Please enter another password and try again.",
    RESET_PASSWORD_FORM_FAILED_CONTENT4: "Your password cannot be the same as your account full name. Please enter another password and try again."


};

export { language }